import { render, staticRenderFns } from "./PartyRiskOperations.vue?vue&type=template&id=6a478654"
import script from "./PartyRiskOperations.vue?vue&type=script&lang=js"
export * from "./PartyRiskOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports